import { UntypedFormControl, Validators } from '@angular/forms';

export class CustomValidatorsGroup extends Validators {
  static onlyLatinChar = '^[A-Za-zÀ-ÖØ-öø-ÿ.\\s-]{0,50}$';
  static emailPattern =
    '^(([^<>()\\[\\]\\.,;:\\s@\\"]+(\\.[^<>()\\[\\]\\.,;:\\s@\\"]+)*)|(\\".+\\"))@(([^<>()[\\]\\.,;:\\s@\\"]+\\.)+[^<>()[\\]\\.,;:\\s@\\"]{2,})$';
  static phoneNumberPattern = '[0-9\\s()+-]+';

  static validateRequiredWithTrim(c: UntypedFormControl) {
    return c.value.trim().length !== 0
      ? null
      : {
          required: true
        };
  }

  static validateRequiredSelect(c: UntypedFormControl) {
    return c.value !== 0
      ? null
      : {
          required: true
        };
  }

  static self_reg = {
    first_name: [
      Validators.required,
      Validators.compose([CustomValidatorsGroup.validateRequiredWithTrim]),
      Validators.pattern(CustomValidatorsGroup.onlyLatinChar)
    ],
    last_name: [
      Validators.required,
      Validators.compose([CustomValidatorsGroup.validateRequiredWithTrim]),
      Validators.pattern(CustomValidatorsGroup.onlyLatinChar)
    ],
    email: [Validators.required, Validators.pattern(CustomValidatorsGroup.emailPattern)],
    work_phone_number: [
      Validators.required,
      Validators.pattern(CustomValidatorsGroup.phoneNumberPattern),
      Validators.compose([CustomValidatorsGroup.validateRequiredWithTrim])
    ],
    mobile_phone_number: [Validators.required, Validators.pattern(CustomValidatorsGroup.phoneNumberPattern)],
    name_title_option: [Validators.compose([CustomValidatorsGroup.validateRequiredSelect])],
    timezone: [Validators.compose([CustomValidatorsGroup.validateRequiredSelect])],
    none: []
  };
}
